import { PropsWithChildren } from "react";

export const AnimatedSidebarHeader = ({
  children,
  id
}: PropsWithChildren<{ id?: string }>) => (
  <div id={id} className="flex flex-col">
    {children}
  </div>
);
